<script setup lang="ts">
import { ref, onUnmounted } from 'vue';
import SignedOutBanner from '@/components/ui/SignedOutBanner.vue';
import { useAuthStore } from '@/stores/auth.store';
import { onSessionChangeFromOtherTab } from '@/integrations/Immersve/auth/sessionChangeSignal';

const auth = useAuthStore();
auth.initialize();

const signedOutElsewhere = ref(false);
const stopListening = onSessionChangeFromOtherTab(async () => {
  const wasAuthenticated = auth.status === 'authenticated';
  await auth.refresh();
  signedOutElsewhere.value = wasAuthenticated && auth.status === 'unauthenticated';
});
onUnmounted(stopListening);
</script>

<template>
  <SignedOutBanner v-if="signedOutElsewhere" @dismiss="signedOutElsewhere = false" />
  <slot />
</template>
